<template>
  <div class="addMain bigMain">
    <div v-if="$route.meta.routeList.length>1" class="returnBtn" @click="goBack()">
      <i class="el-icon-back"></i>
    </div>
    <!-- 配置物模型-->
    <el-card shadow="never">
      <div class="cardTop">
        <h1>配置物模型-下行功能定义</h1>
      </div>
      <div class="cardBottom">
        <div class="addIntroduce">
          <h3>
            配置设备协议的物模型中的下行功能。先点击“
            添加功能”按钮，再添加属性。
            注意顺序，必须按照说明书内协议解析顺序添加。可拖动调整按钮调整顺序。
          </h3>
        </div>
        <div class="tabSuit">
          <el-button class="btnAdd" size="small" @click="addEnclaves('add')">
            添加功能
          </el-button>
          <el-tabs class="configTab" v-model="editableTabsValue2" type="card" closable @tab-remove="removeTab">
            <el-tab-pane v-for="item in editableTabs" :key="item.name" :label="item.title" :name="item.name">
              <!-- 包头信息 -->
              <div class="clearfix">
                <el-button size="small" type="text" class="pull-left" style="margin-left:15px;"
                  @click="clonedEnclaves(item, 'clone')">
                  克隆</el-button>
                <el-button size="small" type="text" class="pull-left" style="margin-left:15px;"
                  @click="modifyBtn(item.id)">
                  编辑</el-button>
                <ul class="infoBt clearfix pull-left">
                  <li>
                    <span>code</span><br />
                    <span>{{ item.packet.code }}</span>
                  </li>
                  <li>
                    <span>下发类型</span><br />
                    <span>{{
                      item.packet.downType == 1
                        ? "下发获取数据"
                        : item.packet.downType == 2
                        ? "下发控制命令"
                        : "---"
                    }}</span>
                  </li>
                  <li v-if="commuType == 3">
                    <span>mqtt topic</span><br />
                    <span>{{
                        item.packet.topic ? item.packet.topic
                          : "---"
                      }}</span>
                  </li>
                  <li v-if="commuType == 3">
                    <span>mqtt qos</span><br />
                    <span>{{
                        item.packet.qos || item.packet.qos === 0 ? item.packet.qos
                          : "---"
                      }}</span>
                  </li>
                  <!-- <li>
                    <span>发送频率（cron表达式）</span><br />
                    <span>{{ item.packet.collectCron }}</span>
                  </li> -->
                </ul>
              </div>

              <!-- table -->
              <el-table :data="item.content.tableData" border row-key="id" align="left">
                <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
                <el-table-column label="名称" prop="name">
                  <template slot-scope="scope">
                    <el-input size="small" v-model="scope.row.name"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="标识" prop="code">
                  <template slot-scope="scope">
                    <el-input size="small" v-model="scope.row.code"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="长度(字节数)" prop="length" v-if="protocolType == 2">
                  <template slot-scope="scope">
                    <el-input size="small" v-model.number="scope.row.length"></el-input>
                  </template>
                </el-table-column>
                <!-- <el-table-column label="数据类型" width="200px"  prop="type">
                <template slot-scope="scope">
                  <el-select  size="small"  v-model="scope.row.dataType" placeholder="未选择">
                        <el-option 
                          v-for="item in dataTypeList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                  </el-select>
                  <el-input v-if="scope.row.dataType==1" v-model="scope.row.dataMin"   style="width:48%" size="small" placeholder="最小值"></el-input>
                  <el-input v-if="scope.row.dataType==1" v-model="scope.row.dataMax" style="width:48%" size="small" placeholder="最大值"></el-input>
                </template>
              </el-table-column> -->
                <el-table-column label="下行字段类型" width="200px" prop="type">
                  <template slot-scope="scope">
                    <el-select size="small" v-model="scope.row.fieldType" placeholder="未选择">
                      <el-option v-for="item in fieldTypeList" :key="item.value" :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                    <!-- <el-input v-if="scope.row.fieldType==1 && item.packet.downType==1 " v-model="scope.row.fieldValue"
                      size="small" placeholder="16进制字符串"></el-input> -->
                    <el-input v-if="scope.row.fieldType == 1 || scope.row.fieldType == 6" v-model="scope.row.fieldValue"
                      size="small"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="字段说明" prop="length">
                  <template slot-scope="scope">
                    <el-input type="textarea" :rows="2" size="small" v-model="scope.row.fieldDesc"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="" prop="" width="130px">
                  <template slot-scope="scope">
                    <el-row>
                      <el-col :span="8">
                        <el-button @click.native.prevent="
                            deleteRow(scope.$index, item.content.tableData)
                          " type="text" size="small">
                          移除
                        </el-button>
                        <br />
                        <el-button @click.native.prevent="
                            copyRow(scope.$index, item.content.tableData)
                          " type="text" size="small">
                          克隆
                        </el-button>
                      </el-col>
                      <el-col :span="8">
                        <el-button style="padding:5px 10px ;margin:4px 0" size="mini" :disabled="scope.$index === 0"
                          @click="
                            moveUp(
                              scope.$index,
                              scope.row,
                              item.content.tableData
                            )
                          "><i class="el-icon-arrow-up"></i></el-button>
                        <br>
                        <el-button style="padding: 5px 10px ;margin:4px 0" size="mini" :disabled="
                            scope.$index === item.content.tableData.length - 1
                          " @click="
                            moveDown(
                              scope.$index,
                              scope.row,
                              item.content.tableData
                            )
                          "><i class="el-icon-arrow-down"></i></el-button>
                      </el-col>
                      <el-col :span="8">
                        <el-button style="padding:5px 10px ;margin:4px 0" size="mini" :disabled="scope.$index === 0"
                          @click="
                            moveTop(
                              scope.$index,
                              scope.row,
                              item.content.tableData
                            )
                          "><i class="el-icon-upload2"></i></el-button>
                        <br>
                        <el-button style="padding: 5px 10px ;margin:4px 0" size="mini" :disabled="
                            scope.$index === item.content.tableData.length - 1
                          " @click="
                            moveBottom(
                              scope.$index,
                              scope.row,
                              item.content.tableData
                            )
                          "><i class="el-icon-download"></i></el-button>
                      </el-col>
                    </el-row>
                  </template>
                </el-table-column>
              </el-table>
              <el-button @click.native.prevent="addRow(item.content.tableData)" type="text" size="small">
                添加行
              </el-button>
            </el-tab-pane>
            <!-- 修改功能 -->
            <el-dialog title="修改功能" :visible.sync="modifyDialog">
              <el-form :model="modifyForm" ref="modifyForm" :rules="rules">
                <el-form-item label="code" prop="code" style="background-color:transparent;border-bottom:none">
                  <el-input v-model="modifyForm.code" placeholder="请输入" autocomplete="off"
                    style="margin-top:30px;width:100%;"></el-input>
                </el-form-item>
                <el-form-item label="功能名称" prop="name" style="background-color:transparent;border-bottom:none">
                  <el-input v-model="modifyForm.name" placeholder="请输入" autocomplete="off"
                    style="margin-top:30px;width:100%;"></el-input>
                </el-form-item>
                <el-form-item label="下发类型" prop="downType" style="background-color:transparent;border-bottom:none">
                  <el-select size="small" v-model="modifyForm.downType" placeholder="未选择"
                    style="margin-top:30px;width:100%">
                    <el-option v-for="item in downTypeList" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item v-if="commuType == 3" label="mqtt主题" prop="topic"
                  style="background-color:transparent;border-bottom:none">
                  <el-input v-model="modifyForm.topic" placeholder="请输入" autocomplete="off"
                    style="margin-top:30px;width:100%;"></el-input>
                </el-form-item>

                <el-form-item v-if="commuType == 3" label="mqtt qos" prop="qos"
                  style="background-color:transparent;border-bottom:none">
                  <el-select size="small" v-model="modifyForm.qos" placeholder="未选择" style="margin-top:30px;width:100%">
                    <el-option v-for="item in qosList" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="modifyDialog = false">取 消</el-button>
                <el-button type="primary" @click="modifyConfirm('modifyForm')">确 定</el-button>
              </div>
            </el-dialog>
          </el-tabs>
        </div>
        <el-form>
          <el-form-item>
            <el-button type="text" @click="$router.history.go(-1)">取消</el-button>
            <el-button v-if="flag != 'edit'" type="primary" @click="onSubmit()">完成</el-button>
            <el-button v-if="flag == 'edit'" type="primary" @click="editOnSubmit()">修改</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <!-- 创建功能 -->
    <el-dialog title="创建功能" :visible.sync="dialogFormVisible">
      <el-form :model="editForm" ref="editForm" :rules="rules">
        <el-form-item label="功能编码" prop="code" style="background-color:transparent;border-bottom:none">
          <el-input v-model="editForm.code" placeholder="请输入" autocomplete="off" style="margin-top:30px;width:100%;">
          </el-input>
        </el-form-item>
        <el-form-item label="功能名称" prop="name" style="background-color:transparent;border-bottom:none">
          <el-input v-model="editForm.name" placeholder="请输入" autocomplete="off" style="margin-top:30px;width:100%;">
          </el-input>
        </el-form-item>
        <el-form-item label="下发类型" prop="downType" style="background-color:transparent;border-bottom:none">
          <el-select size="small" v-model="editForm.downType" placeholder="未选择" style="margin-top:30px;width:100%">
            <el-option v-for="item in downTypeList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item v-if="commuType == 3" label="mqtt主题" prop="topic"
          style="background-color:transparent;border-bottom:none">
          <el-input v-model="editForm.topic" placeholder="请输入" autocomplete="off" style="margin-top:30px;width:100%;">
          </el-input>
        </el-form-item>

        <el-form-item v-if="commuType == 3" label="mqtt qos" prop="qos"
          style="background-color:transparent;border-bottom:none">
          <el-select size="small" v-model="editForm.qos" placeholder="未选择" style="margin-top:30px;width:100%">
            <el-option v-for="item in qosList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item
          label="下发频率"
          prop="collectCron"
          style="background-color:transparent"
        >
          <el-input
            v-model="editForm.collectCron"
            placeholder="请输入cron表达式"
            autocomplete="off"
            style="margin-top:30px;width:100%;"
          ></el-input>
          <br />
          <div class="subheading">
            Cron表达式填写方式：Cron表达式仅支持5位，不支持秒；您可以参考
            <el-button type="text" @click="cronDetail" style="float:none"
              >详细表达式</el-button
            >
            <br />
            <el-button type="text" @click="cronConvert" style="float:none"
              >CRON转换器</el-button
            >
          </div>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirm('editForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import API from "../../api/api";
  import Sortable from "sortablejs";
  export default {
    data() {
      return {
        user_name: this.$cookies.get("user_name"),
        commuType: sessionStorage.getItem('commuType'),
        distinguish: "",
        cloneTarget: {},
        //校验
        rules: {
          downType: [{
            required: true,
            message: "请选择下发类型",
            trigger: "change"
          }],
          code: [{
            required: true,
            message: "请填写功能code值",
            trigger: "blur"
          }],
          name: [{
            required: true,
            message: "请填写功能名称",
            trigger: "blur"
          }]
        },
        flag: this.$route.query.flag,
        ids: this.$route.query.id,
        protocolType: this.$route.query.protocolType,
        dialogFormVisible: false, //创建窗口
        modifyDialog: false, //修改窗口
        editForm: {}, //创建窗口数据
        modifyForm: {}, //修改窗口数据
        editableTabsValue2: "1",
        editableTabs: [],
        dataTypeList: [
          //数据类型下拉
          {
            value: 2,
            label: "布尔类型"
          },
          {
            value: 1,
            label: "数值类型"
          },
          {
            value: 3,
            label: "字符串"
          }
        ],
        storageList: [
          //数据是否存储
          {
            value: 0,
            label: "不存储"
          },
          {
            value: 1,
            label: "存储"
          }
        ],
        downTypeList: [
          //下发类型下拉
          {
            value: 1,
            label: "下发获取数据"
          },
          {
            value: 2,
            label: "下发控制命令"
          }
        ],
        qosList: [
          //下发类型下拉
          {
            value: 0,
            label: "0"
          },
          {
            value: 1,
            label: "1"
          },
          {
            value: 2,
            label: "2"
          }
        ],
        fieldTypeList: [
          //下行字段类型
          // {
          //   value: 99,
          //   label: "无"
          // },
          {
            value: 1,
            label: "16进制"
          },
          {
            value: 2,
            label: "子设备地址号"
          },
          {
            value: 3,
            label: "16进制和"
          },
          {
            value: 4,
            label: "Modbus CRC校验和"
          },
          {
            value: 5,
            label: "需要动态传入参数类型"
          },
          {
            value: 6,
            label: "字符串"
          },
        ]
      };
    },
    created() {},
    methods: {
      copyRow(index, rows) {
        let target = Object.assign({}, rows[index]);
        target.id = null;
        //浅复制
        rows.push(target);
      },



      //表格移除功能
      deleteRow(index, rows) {
        rows.splice(index, 1);
      },
      //表格添加行
      addRow(row) {
        row.push({});
      },
      //添加功能弹框
      addEnclaves(distinguish) {
        this.dialogFormVisible = true;
        this.distinguish = distinguish; //区分是克隆还是新增功能
      },
      //克隆功能
      clonedEnclaves(row, distinguish) {
        this.dialogFormVisible = true;
        //只需要克隆table里面的数据
        this.distinguish = distinguish; //区分是克隆还是新增功能
        let target = Object.assign({}, row);
        target.content.tableData.forEach(ele => {
          ele.id = null;
        });
        target.content.id = null;
        target.content.name = null;
        target.content.title = null;
        this.cloneTarget = target;
      },
      //上移
      moveUp(index, row, data) {
        if (index > 0) {
          let upDate = data[index - 1];
          data.splice(index - 1, 1);
          data.splice(index, 0, upDate);
        } else {
          alert("已经是第一条，不可上移");
        }
      },
      //下移
      moveDown(index, row, data) {
        if (index + 1 === data.length) {
          alert("已经是最后一条，不可下移");
        } else {
          let downDate = data[index + 1];
          data.splice(index + 1, 1);
          data.splice(index, 0, downDate);
        }
      },
      moveTop(index, row, data) {
        if (index > 0) {
          let topDate = data[index];
          data.splice(index, 1);
          data.unshift(topDate)
        } else {
          alert("已经是第一条，不可上移");
        }
      },
      moveBottom(index, row, data) {
        if (index + 1 === data.length) {
          alert("已经是最后一条，不可下移");
        } else {
          let bottomDate = data[index];
          data.splice(index, 1);
          data.push(bottomDate)
        }
      },
      //点击进入编辑页
      modifyBtn(id) {
        API.platformDevProtocolViewPacket(id).then(res => {
          if (res.code == 1) {
            this.modifyForm = res.data; //给该功能内容赋值
            this.modifyDialog = true;
          }
        });
      },
      //编辑页面的完成按钮
      modifyConfirm(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            let para = {
              id: this.modifyForm.id,
              code: this.modifyForm.code,
              name: this.modifyForm.name,
              collectCron: this.modifyForm.collectCron,
              downType: this.modifyForm.downType,
              packetType: 2,
              topic: this.modifyForm.topic,
              qos: this.modifyForm.qos
            };
            let _this = this;
            if (this.user_name == 'suadmin') {
              //修改功能头信息
              API.editPlatformDevProtocolPacketCommon(para.id, para).then(res => {
                if (res.code == 1) {
                  _this.$message.success("修改成功");
                  _this.modifyDialog = false;
                  //用index找到当前组数据
                  _this.editableTabs.findIndex(ele => {
                    if (_this.modifyForm.id == ele.id) {
                      //当前id跟遍历出来的id相同时就是这个功能的数据
                      ele.packet = _this.modifyForm;
                      ele.name = _this.modifyForm.name;
                      ele.title = _this.modifyForm.name;
                      ele.topic = _this.modifyForm.topic;
                      ele.qos = _this.modifyForm.qos;
                      _this.editableTabsValue2 = _this.modifyForm.name;
                    }
                  });
                } else {
                  this.$message.error(res.msg);
                }
              });
              return;
            }
            //修改功能头信息
            API.editPlatformDevProtocolPacketPrivate(para.id, para).then(res => {
              if (res.code == 1) {
                _this.$message.success("修改成功");
                _this.modifyDialog = false;
                //用index找到当前组数据
                _this.editableTabs.findIndex(ele => {
                  if (_this.modifyForm.id == ele.id) {
                    //当前id跟遍历出来的id相同时就是这个功能的数据
                    ele.packet = _this.modifyForm;
                    ele.name = _this.modifyForm.name;
                    ele.title = _this.modifyForm.name;
                    ele.topic = _this.modifyForm.topic;
                    ele.qos = _this.modifyForm.qos;
                    _this.editableTabsValue2 = _this.modifyForm.name;
                  }
                });
              } else {
                this.$message.error(res.msg);
              }
            });
          } else {
            this.$message.error("请填写完所有必填项");
            return false;
          }
        });
      },
      //新增
      confirm(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            let para = {
              name: this.editForm.name,
              code: this.editForm.code,
              downType: this.editForm.downType,
              collectCron: this.editForm.collectCron,
              packetType: 2, //下行包
              topic: this.editForm.topic,
              qos: this.editForm.qos,
              devProtocolId: this.ids
            };
            if (this.user_name == 'suadmin') {
              //新建功能
              API.platformDevProtocolPacketCommon(para).then(res => {
                if (res.code == 1) {
                  let newTabName = this.editForm.name;
                  //新增功能
                  if (this.distinguish == "add") {
                    //创建功能空table
                    this.editableTabs.push({
                      title: newTabName,
                      name: newTabName,
                      id: res.data.id,
                      packet: res.data,
                      content: {
                        tableData: []
                      }
                    });
                    //克隆功能操作
                  } else if (this.distinguish == "clone") {
                    let _this = this;
                    this.editableTabs.push({
                      title: newTabName,
                      name: newTabName,
                      id: res.data.id,
                      packet: res.data,
                      content: {
                        tableData: _this.cloneTarget.content.tableData
                      }
                    });
                  }

                  this.editableTabsValue2 = newTabName;
                  this.dialogFormVisible = false; //隐藏创建窗口
                  this.editForm.name = ""; //创建完，初始化创建窗口信息
                  this.editForm.code = ""; //创建完，初始化创建窗口信息
                  this.editForm.downType = ""; //创建完，初始化创建窗口信息
                  this.editForm.collectCron = ""; //创建完，初始化创建窗口信息
                } else {
                  this.$message.error(res.msg);
                }
              });
              return;
            }
            //新建功能
            API.platformDevProtocolPacketPrivate(para).then(res => {
              if (res.code == 1) {
                let newTabName = this.editForm.name;
                //新增功能
                if (this.distinguish == "add") {
                  //创建功能空table
                  this.editableTabs.push({
                    title: newTabName,
                    name: newTabName,
                    id: res.data.id,
                    packet: res.data,
                    content: {
                      tableData: []
                    }
                  });
                  //克隆功能操作
                } else if (this.distinguish == "clone") {
                  let _this = this;
                  this.editableTabs.push({
                    title: newTabName,
                    name: newTabName,
                    id: res.data.id,
                    packet: res.data,
                    content: {
                      tableData: _this.cloneTarget.content.tableData
                    }
                  });
                }

                this.editableTabsValue2 = newTabName;
                this.dialogFormVisible = false; //隐藏创建窗口
                this.editForm.name = ""; //创建完，初始化创建窗口信息
                this.editForm.code = ""; //创建完，初始化创建窗口信息
                this.editForm.downType = ""; //创建完，初始化创建窗口信息
                this.editForm.collectCron = ""; //创建完，初始化创建窗口信息
              } else {
                this.$message.error(res.msg);
              }
            });
          } else {
            this.$message.error("请填写完所有必填项");
            return false;
          }
        });

        //  setTimeout(() => {
        //     this.rowDrop(this.editableTabs.content.tableData);
        //  }, 2000);
      },

      //删除功能，需要调接口
      removeTab(targetName) {
        let tabs = this.editableTabs;
        let activeName = this.editableTabsValue2;
        if (activeName == targetName) {
          tabs.forEach((tab, index) => {
            if (tab.name === targetName) {
              let para = {
                ids: tab.id
              };
              this.$confirm("此操作将永久删除该功能, 是否继续?", "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning"
                })
                .then(() => {
                  if (this.user_name == 'suadmin') {
                    API.delPlatformDevProtocolDeviceProtocolPacketCommon(para).then(
                      res => {
                        if (res.code == 1) {
                          this.$message.success("删除成功");
                          let nextTab = tabs[index + 1] || tabs[index - 1];
                          if (nextTab) {
                            activeName = nextTab.name;
                          }
                          this.editableTabsValue2 = activeName;
                          this.editableTabs = tabs.filter(
                            tab => tab.name !== targetName
                          );
                        } else {
                          this.$message.error(res.msg);
                        }
                      }
                    );
                    return;
                  }
                  API.delPlatformDevProtocolDeviceProtocolPacketPrivate(para).then(
                    res => {
                      if (res.code == 1) {
                        this.$message.success("删除成功");
                        let nextTab = tabs[index + 1] || tabs[index - 1];
                        if (nextTab) {
                          activeName = nextTab.name;
                        }
                        this.editableTabsValue2 = activeName;
                        this.editableTabs = tabs.filter(
                          tab => tab.name !== targetName
                        );
                      } else {
                        this.$message.error(res.msg);
                      }
                    }
                  );
                })
                .catch(() => {
                  this.$message({
                    type: "info",
                    message: "已取消删除"
                  });
                });
            }
          });
        }
      },
      //行拖拽
      rowDrop(tableData) {
        const tbody = document.querySelector(".el-table__body-wrapper tbody");
        // const _this = this
        Sortable.create(tbody, {
          onEnd({
            newIndex,
            oldIndex
          }) {
            const currRow = tableData.splice(oldIndex, 1)[0];
            tableData.splice(newIndex, 0, currRow);
          }
        });
      },
      //创建下行功能数据
      onSubmit() {
        //把序号fieldOrder传过去给后台
        for (let i = 0; i < this.editableTabs.length; i++) {
          for (
            let j = 0; j < this.editableTabs[i].content.tableData.length; j++
          ) {
            this.editableTabs[i].content.tableData[j].fieldOrder = j + 1;
          }
        }
        if (this.user_name == 'suadmin') {
          API.platformDevProtocolPacketFieldCommon(this.editableTabs).then(res => {
            if (res.code == 1) {
              this.$message.success("配置下行功能成功");
              this.$router.push({
                path: "/equipment/equipmentProtocolLibrary"
              });
            } else {
              this.$message.error(res.msg);
            }
          });
          return;
        }
        API.platformDevProtocolPacketFieldPrivate(this.editableTabs).then(res => {
          if (res.code == 1) {
            this.$message.success("配置下行功能成功");
            this.$router.push({
              path: "/equipment/equipmentProtocolLibrary"
            });
          } else {
            this.$message.error(res.msg);
          }
        });
      },
      /**********************修改操作B***************************** */

      //获取下行数据
      getMage() {
        if (this.flag == "edit") {
          let id = this.$route.query.id;
          //获取物模型-下行
          API.platformDevProtocolViewPacketAndField(this.ids, 2).then(res => {
            // 2代表下行包数据
            if (res.code == 1) {
              if (res.data.length != 0) {
                this.editableTabs = res.data;
                this.editableTabsValue2 = res.data[0].name;
              }
            }
          });
        }
      },
      //修改上行包数据
      editOnSubmit() {
        //把序号fieldOrder传过去给后台
        for (let i = 0; i < this.editableTabs.length; i++) {
          for (
            let j = 0; j < this.editableTabs[i].content.tableData.length; j++
          ) {
            this.editableTabs[i].content.tableData[j].fieldOrder = j + 1;
          }
        }
        if (this.user_name == 'suadmin') {
          API.editPlatformDevProtocolPacketFieldCommon(this.editableTabs).then(res => {
            if (res.code == 1) {
              this.$message.success("修改成功");
              this.$router.history.go(-1);
            } else {
              this.$message.error(res.msg);
            }
          });
          return;
        }
        API.editPlatformDevProtocolPacketFieldPrivate(this.editableTabs).then(res => {
          if (res.code == 1) {
            this.$message.success("修改成功");
            this.$router.history.go(-1);
          } else {
            this.$message.error(res.msg);
          }
        });
      }
      /**********************修改操作E ***************************** */
    },
    mounted() {
      this.getMage();
    }
  };

</script>



// WEBPACK FOOTER //
// src/views/platform/downlinkPackage.vue